import { classes } from "#palette/style";

function ProgressItem(props: { color: string }) {
  return <div className={classes(["w-full h-5 rounded-xl", props.color])} />;
}

export function Progressbar(props: { segments: number; complete: number }) {
  const theseSegments: JSX.Element[] = [];
  for (let n = 0; n < props.segments; n++) {
    const color =
      n === props.complete - 1
        ? "bg-brand-900"
        : n < props.complete
          ? "bg-brand-500"
          : "bg-brand-50";
    theseSegments.push(<ProgressItem color={color} />);
  }

  return (
    <div className="mb-5 flex gap-5 justify-between">
      {theseSegments.map((s) => s)}
    </div>
  );
}
